const PERMISSIONS_PRODUCT_GROUP_PAGE = {
  VIEW: 'kiosk_product_group::get',
  CREATE: 'kiosk_product_group::create',
  UPDATE: 'kiosk_product_group::update',
  DELETE: 'kiosk_product_group::delete',
  SET_PRODUCTS: 'kiosk_product_group::set_products',
} as const;

export const PRODUCT_GROUP_PERMISSIONS = [
  PERMISSIONS_PRODUCT_GROUP_PAGE.VIEW,
  PERMISSIONS_PRODUCT_GROUP_PAGE.CREATE,
  PERMISSIONS_PRODUCT_GROUP_PAGE.UPDATE,
  PERMISSIONS_PRODUCT_GROUP_PAGE.DELETE,
  PERMISSIONS_PRODUCT_GROUP_PAGE.SET_PRODUCTS,
] as const;

export default PERMISSIONS_PRODUCT_GROUP_PAGE;
